const NumberPagination = ({
  className,
  length,
  actived,
  onPageChange,
  position = "center",
}) => {
  const ELLIPSIS = "...";

  // Generate pagination items with ellipsis
  const getPaginationItems = () => {
    const items = [];
    const totalPages = Number(length) || 0;
    const currentPage = Number(actived) || 1;

    // Validate inputs
    if (!totalPages || totalPages <= 0) {
      return [];
    }

    // Ensure currentPage is within valid range
    const validCurrentPage = Math.max(1, Math.min(currentPage, totalPages));

    if (totalPages <= 4) {
      // Show all pages if total is 4 or less
      for (let i = 1; i <= totalPages; i++) {
        items.push(i);
      }
    } else {
      // Always show first page
      items.push(1);

      // Strategy: Show exactly 4 numbers total (1, current-1, current, current+1, or similar)
      // But adjust based on position

      if (validCurrentPage <= 3) {
        // Near start: show 1, 2, 3, 4, ..., last
        for (let i = 2; i <= 4; i++) {
          items.push(i);
        }
        items.push(ELLIPSIS);
        items.push(totalPages);
      } else if (validCurrentPage >= totalPages - 2) {
        // Near end: show 1, ..., last-3, last-2, last-1, last
        items.push(ELLIPSIS);
        for (let i = totalPages - 3; i <= totalPages; i++) {
          items.push(i);
        }
      } else {
        // Middle: show 1, ..., current-1, current, current+1, ..., last
        items.push(ELLIPSIS);
        items.push(validCurrentPage - 1);
        items.push(validCurrentPage);
        items.push(validCurrentPage + 1);
        items.push(ELLIPSIS);
        items.push(totalPages);
      }
    }

    return items;
  };

  const paginationItems = getPaginationItems();

  return (
    <div
      className={`w-full flex flex-row items-center ${
        position === "center"
          ? "justify-center"
          : position === "left"
          ? "justify-start"
          : "justify-end"
      } gap-[7px] ${className}`}
    >
      {paginationItems.map((item, index) => {
        if (item === ELLIPSIS) {
          return (
            <span
              key={`ellipsis-${index}`}
              className="text-[15px] font-medium text-gray-500"
            >
              ...
            </span>
          );
        }

        return (
          <button
            key={item}
            className={`text-[15px] font-medium transition-colors duration-200 hover:text-primary ${
              actived === item ? "text-primary" : "text-[#8894B9]"
            }`}
            onClick={() => onPageChange(item)}
          >
            {item}
          </button>
        );
      })}
    </div>
  );
};

export default NumberPagination;
